var React = require('react');

function Brand (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m75 390h362c41.355469 0 75-33.644531 75-75v-240c0-41.355469-33.644531-75-75-75h-362c-41.355469 0-75 33.644531-75 75v240c0 41.355469 33.644531 75 75 75zm-45-315c0-24.8125 20.1875-45 45-45h362c24.8125 0 45 20.1875 45 45v240c0 24.8125-20.1875 45-45 45h-362c-24.8125 0-45-20.1875-45-45zm0 0","key":0}),React.createElement("path",{"d":"m181 94.507812v203.898438l180.5-103.621094zm30 50.984376 89.5 49.722656-89.5 51.378906zm0 0","key":1})]);
}

Brand.defaultProps = {"viewBox":"0 -61 512 512"};

module.exports = Brand;

Brand.default = Brand;
